import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { trackEvent } from '../utils/analytics';
export type Language = 'en' | 'es';
interface LanguageContextValue {
  lang: Language;
  setLang: (lang: Language) => void;
  t: <T>(en: T, es: T) => T;
}
const LanguageContext = createContext<LanguageContextValue | null>(null);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLangState] = useState<Language>('en');
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const setLang = useCallback((next: Language) => {
    setLangState(current => {
      if (current !== next) {
        trackEvent('language_switch', {
          language: next
        });
      }
      return next;
    });
  }, []);
  const value = useMemo<LanguageContextValue>(() => ({
    lang,
    setLang,
    t: <T,>(en: T, es: T) => lang === 'en' ? en : es
  }), [lang, setLang]);
  return <LanguageContext.Provider value={value} data-id="element-451" data-mp="2jn1g0ujcpbjl">{children}</LanguageContext.Provider>;
}
export function useLanguage(): LanguageContextValue {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}